import { Modal as ADModal } from "antd";

/**
 * Common Modal Component with processing state
 * @param {import('antd').ModalProps & { isProcessing?: boolean }} props
 * @property {boolean} [isProcessing=false] - If true, disables close interactions and action buttons
 */
const Modal = ({ isProcessing = false, children, ...restProps }) => {
  return (
    <ADModal
      closable={!isProcessing}
      maskClosable={!isProcessing}
      keyboard={!isProcessing}
      okButtonProps={{
        ...restProps.okButtonProps,
        disabled: isProcessing,
        loading: isProcessing,
      }}
      cancelButtonProps={{
        ...restProps.cancelButtonProps,
        disabled: isProcessing,
      }}
      {...restProps}
    >
      {children}
    </ADModal>
  );
};

export default Modal;
